import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import LicensesInUseListRow from "./LicensesInUseListRow";

class index extends Component {
  render() {
    const { licensesInUse } = this.props;

    let rows = [];
    if (licensesInUse) {
      for (let i = 0; i < licensesInUse.length; i++) {
        const licenseInUse = licensesInUse[i];
        rows.push(<LicensesInUseListRow key={licenseInUse.Id} licenseInUse={licenseInUse} />);
      }
    }

    return (
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Application</th>
              <th>User</th>
              <th>Date</th>
              <th>Expiry</th>
              <th>Type</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }
}
export default inject("stores")(observer(index));



// WEBPACK FOOTER //
// ./src/Components/LicensesInUseList/index.js